// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3p1-g","label":"styles_label__2dKJB"};